<template>
  <div>
    <p v-if="isLoading" class="text-subtle p-4">Hämtar ansökan...</p>
    <p v-else-if="error" class="error-text p-4">{{ error }}</p>

    <template v-else-if="application">
      <div class="min-w-0 flex flex-col gap-6">
        <CommitmentDetailsSection :section="applicationSections.commitmentDetails" />
        <RepaymentCapacitySection :section="applicationSections.repaymentCapacity" />
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useApplicationContext } from '@/views/application/application.context'
import CommitmentDetailsSection from '@/views/application/overview/components/sections/CommitmentDetailsSection.vue'
import RepaymentCapacitySection from '@/views/application/overview/components/sections/RepaymentCapacitySection.vue'
import { applicationSections } from '@/views/application/overview/components/sections/sections'

const { application, isLoading, error } = useApplicationContext()
</script>
